export const AUTH_COOKIE_SESSION_EXPIRED_KEY = 'authenticated'
export const AUTH_COOKIE_LOGGED_OUT_KEY = 'logged-out'

/**
 * Key for authentication mode, indicating whether the user is impersonating a customer or using a normal customer account.
 */
export const AUTH_COOKIE_AUTHENTICATION_MODE_KEY = 'authentication-mode'

/**
 * Key for authentication token for internal users (e.g., admins, support staff).
 */
export const AUTH_COOKIE_INTERNAL_TOKEN_KEY = 'internal-auth-token'

/**
 * Key for authentication token when impersonating another user.
 */
export const AUTH_COOKIE_IMPERSONATE_TOKEN_KEY = 'login-as-auth-token'

/**
 * Key for authentication token for punchout users.
 */
export const AUTH_COOKIE_PUNCHOUT_TOKEN_KEY = 'punchout-auth-token'

/**
 * Key for storing hook URL in punchout session.
 */
export const AUTH_COOKIE_PUNCHOUT_HOOK_KEY = 'punchout-hook-url'

/**
 * Property keys for JSON object stored within AUTH_COOKIE_PUNCHOUT_HOOK_KEY.
 */
export const PUNCHOUT_HOOK_URL_COOKIE_PROP = 'hookUrl'
export const PUNCHOUT_BACK_TO_ERP_URL_COOKIE_PROP = 'backToERPUrl'

/**
 * Key for storing when a user just logged in after a password change
 */
export const AUTH_COOKIE_PASSWORD_CHANGED_KEY = 'password-changed'

/**
 * Key for storing user organization when an SSO authentication error occurs.
 */
export const AUTH_COOKIE_SSO_ERROR_ORGANIZATION_KEY = 'sso-error-user-organization'

/**
 * Expiration duration for internal collaborator session token (24 hours).
 */
export const INTERNAL_SESSION_COOKIE_DURATION = 24 * 60 * 60

/**
 * Expiration duration for impersonation session token (90 minutes).
 */
export const IMPERSONATION_SESSION_COOKIE_DURATION = 90 * 60
